import { useEffect } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';
import type { IDayPartBoundary } from 'state/menu/main-menu/types';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

export const useDragonBallExperiment = (
  skipLoggingExposure: boolean = false,
  activeDayParts: ReadonlyArray<IDayPartBoundary> = []
) => {
  const { getVariantValue, logExposure } = useExperiments();

  const isBreakfastActive = activeDayParts.some(
    dayPart => dayPart.key.toLowerCase() === 'breakfast'
  );

  const isCanada = region === Region.CA;
  const variantValue = isCanada
    ? undefined
    : getVariantValue(RunningExperiments.DragonBallAppTakeover)?.value;
  const canViewTakeover = isCanada || variantValue === 'treatment';

  useEffect(() => {
    if (skipLoggingExposure || !variantValue || isBreakfastActive) {
      return;
    }

    logExposure(RunningExperiments.DragonBallAppTakeover);
  }, [isBreakfastActive, logExposure, skipLoggingExposure, variantValue]);

  return canViewTakeover;
};
